import angular from 'angular'

type StateParams = {
  token?: string
}

export class MagicLinkController {
  static $inject = ['$stateParams']

  token: string

  constructor($stateParams: StateParams) {
    this.token = $stateParams.token ?? ''
  }
}

angular.module('app').controller('MagicLinkController', MagicLinkController)
